import { Table, TableBody, TableCell, TableFooter, TableRow } from "@material-ui/core";
import { calculateQuarterly, calculateYearly, formatMoneyCents } from "../../helpers";
import { BlackCellBorderWhite, BrightYellowCellBorder, LightGreyCell, StyledTableRow } from "../Page/TableStyles";

export default function MinimumSavingsTable(props) {
    const {formData, dailyProduction} = props;

    return (
        <Table size='small'>
            <TableBody>
                <StyledTableRow>
                    <BlackCellBorderWhite>
                        Minimum Savings Breakdown
                    </BlackCellBorderWhite>
                </StyledTableRow>
                <StyledTableRow>
                    <BrightYellowCellBorder>Night Time Usage</BrightYellowCellBorder>
                    <BrightYellowCellBorder>KWH Daily</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Available FIT</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Daily Savings</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Quarterly Savings</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Annual Savings</BrightYellowCellBorder>
                </StyledTableRow>
                <StyledTableRow>
                    <LightGreyCell>100%</LightGreyCell>
                    <LightGreyCell>{dailyProduction}</LightGreyCell>
                    <LightGreyCell>{formData.feedInTariff}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(dailyProduction * formData.feedInTariff)}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(calculateQuarterly(dailyProduction * formData.feedInTariff))}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(calculateYearly(dailyProduction * formData.feedInTariff))}</LightGreyCell>
                </StyledTableRow>
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={6}>
                        Your minimum savings breakdown is based on if you used NO power during the day, this is what you can expect to save if all power generated by the solar system was sold to your energy provider
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}